import { render } from "./TaskAssessmentModal.vue?vue&type=template&id=89f4fbc8&scoped=true"
import script from "./TaskAssessmentModal.vue?vue&type=script&lang=js"
export * from "./TaskAssessmentModal.vue?vue&type=script&lang=js"

import "./TaskAssessmentModal.vue?vue&type=style&index=0&id=89f4fbc8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89f4fbc8"]])

export default __exports__